import React, { useEffect, useState } from 'react';
const PURCHASES = [{
  name: 'María L.',
  city: 'Bogotá, Colombia'
}, {
  name: 'Carolina S.',
  city: 'Ciudad de México, México'
}, {
  name: 'Valentina R.',
  city: 'Lima, Perú'
}, {
  name: 'Luciana M.',
  city: 'Santiago, Chile'
}, {
  name: 'Florencia G.',
  city: 'Buenos Aires, Argentina'
}, {
  name: 'Romina P.',
  city: 'Quito, Ecuador'
}, {
  name: 'Agustina D.',
  city: 'Montevideo, Uruguay'
}, {
  name: 'Camila T.',
  city: 'Guadalajara, México'
}, {
  name: 'Daniela F.',
  city: 'Medellín, Colombia'
}, {
  name: 'Sofía B.',
  city: 'Caracas, Venezuela'
}, {
  name: 'Antonella V.',
  city: 'Asunción, Paraguay'
}, {
  name: 'Belén O.',
  city: 'La Paz, Bolivia'
}, {
  name: 'Julieta C.',
  city: 'San José, Costa Rica'
}, {
  name: 'Micaela H.',
  city: 'Guayaquil, Ecuador'
}, {
  name: 'Paula E.',
  city: 'Monterrey, México'
}];
function getRandomMinutes() {
  return Math.floor(Math.random() * 25) + 2;
}
function getRandomIndex(exclude: number) {
  let next = Math.floor(Math.random() * PURCHASES.length);
  while (next === exclude && PURCHASES.length > 1) {
    next = Math.floor(Math.random() * PURCHASES.length);
  }
  return next;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(() => Math.floor(Math.random() * PURCHASES.length));
  const [minutes, setMinutes] = useState(getRandomMinutes());
  useEffect(() => {
    const initial = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(initial);
  }, []);
  useEffect(() => {
    if (!visible) return;
    const hide = setTimeout(() => {
      setVisible(false);
      const showNext = setTimeout(() => {
        setCurrentIndex(prev => getRandomIndex(prev));
        setMinutes(getRandomMinutes());
        setVisible(true);
      }, 3000);
      return () => clearTimeout(showNext);
    }, 4000);
    return () => clearTimeout(hide);
  }, [visible, currentIndex]);
  const purchase = PURCHASES[currentIndex];
  return <div className={`fixed bottom-4 left-4 z-[60] max-w-[220px] transition-all duration-500 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-173">
      <div className="bg-[#1a1f3d] border border-[#d4af37]/20 rounded-lg p-2.5 shadow-lg" data-id="element-174">
        <div className="flex items-start gap-2" data-id="element-175">
          <div className="w-7 h-7 rounded-full bg-[#d4af37]/15 border border-[#d4af37]/30 flex items-center justify-center flex-shrink-0" data-id="element-176">
            <span className="text-xs" data-id="element-177">✨</span>
          </div>
          <div className="min-w-0" data-id="element-178">
            <p className="text-[#f5f1e6] text-xs font-semibold leading-tight" data-id="element-179">
              {purchase.name}
              <span className="text-[#cbd0e0] font-normal" data-id="element-180"> de </span>
              <span className="text-[#d4af37]" data-id="element-181">{purchase.city}</span>
            </p>
            <p className="text-[#cbd0e0] text-[11px] mt-0.5 leading-snug" data-id="element-182">
              adquirió la{' '}
              <span className="text-[#f5f1e6] font-semibold" data-id="element-183">
                Formación en Astrología
              </span>
            </p>
            <p className="text-[#8b91ad] opacity-80 text-[10px] mt-0.5" data-id="element-184">
              hace {minutes} minutos
            </p>
          </div>
        </div>
      </div>
    </div>;
}